$(document).ready(function () {
    var windowWidthOnce = window.innerWidth
        ? window.innerWidth
        : $(window).width();


    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var video = document.querySelectorAll("video");

    //add source to video tag
    function addSourceToVideo(element, src) {
        if (element.childElementCount == 0) {
            var source = document.createElement("source");
            source.src = src;
            source.type = "video/mp4";
            element.appendChild(source);
        }
    }

    //determine screen size and select mobile or desktop vid
    function whichSizeVideo(element, src) {
        var windowWidth = window.innerWidth
            ? window.innerWidth
            : $(window).width();
        if (windowWidth > 768) {
            addSourceToVideo(element, src.dataset.desktopVid);
        } else {
            // disabilito i video in modalità mobile (non servono)
            addSourceToVideo(element, src.dataset.mobileVid);
        }
    }

    //init only if page has videos
    function videoSize() {
        if (video !== undefined) {
            video.forEach(function (element, index) {
                if ($(element).isInViewport()) {
                    whichSizeVideo(
                        element, //element
                        element //src locations
                    );
                    if (!element.autoplay) {
                        element.classList.add("lazyloaded");
                        element.autoplay = true;
                        element.load();
                    }
                }
            });
        }
    }
    videoSize();

    var lastScrollTop = 0;
    var lastdirection = "down";
    var changeddirection = 0;
    $(window).on("resize scroll", function () {
        if ($(".header-video-bg").length > 0) {
            videoSize();
        }
    });

});
